/* eslint-disable */
import React from "react";
import { Link } from 'react-router-dom';

import ArrowRight from '../../assets/img/icon_arrow_right.png';
import ArrowRightEnd from '../../assets/img/icon_arrow_right_end.png';

function Paging({ currentPage, totalPages, onPageChange }) {
  const pageNumbers = [];

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  return (
    <div className="adm_com_paging">
      <button
        className="btn_first"
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      >
        <img src={ArrowRightEnd} alt="end" />
      </button>
      <button
        className="btn_prev"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <img src={ArrowRight} alt="prev" />
      </button>
      {pageNumbers.map(number => (
        <button
          key={number}
          className={`btn_page ${currentPage === number ? "active" : ""}`}
          onClick={() => onPageChange(number)}
        >
          {number}
        </button>
      ))}
      <button
        className="btn_next"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <img src={ArrowRight} alt="next" />
      </button>
      <button
        className="btn_last"
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        <img src={ArrowRightEnd} alt="end" />
      </button>
    </div>
  );
}

export default Paging;